// extracted by mini-css-extract-plugin
export default {"themeBtn":"ThemeChanger_themeBtn__2gw9z","App-logo-spin":"ThemeChanger_App-logo-spin__y4qNQ"};